import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import LoginIndex from '@/components/LoginIndex'
import Organization from '@/components/Setting/Organization'
import SystemLog from '@/components/Setting/SystemLog'
import Opm from '@/components/Setting/Opm'
import UserInfo from '@/components/Setting/UserInfo'
import { Message } from "element-ui";
import Util from '../util/util'
let _util = new Util()


Vue.use(Router)

const router =  new Router({
  
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/loginIndex',
      name: 'loginIndex',
      component: LoginIndex
    },
    {
      path: '/Set/systemLog',
      name: '/Set/systemLog',
      component: SystemLog
    },
    {
      path: '/Set/groupManagement',
      name: '/Set/groupManagement',
      component: Organization
    },
    {
      path: '/Set/organizationPersonnelManage',
      name: '/Set/organizationPersonnelManage',
      component: Opm
    },
    {
        path: '/Set/userinfo',
        name:'/Set/userinfo',
        component: UserInfo
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.path != '/') {
    let userInfo = _util.getStorage('ssoUserInfo');
    if(userInfo) {
      console.log(userInfo)
      if (userInfo.updatePwdDays > 180 && to.path != '/Set/userinfo') {
        Message({
          type:'warning',
          message:'密码使用周期为180天！请修改密码！'
        })
        router.push({
          path: '/Set/userinfo'
        })
      } else {
        next()
      }
    } else {
      router.push({
        path: '/'
      })
    }
  } else {
    next()
  }
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default router


// WEBPACK FOOTER //
// ./src/router/index.js